import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_542dbb8244055def7e2942da0a515fa8/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
/* eslint-disable max-len */ /* eslint-disable no-unused-vars */ import logger from 'common/utils/udp-logger';
import { getConfig } from 'portal-common/config';
import { API_PROXY_PREFIX, OPM_LIST_TAG } from 'portal-common/constants';
import { CONFIG_KEYS, NAMESPACE } from 'portal-common/constants/requestConstants';
import { api } from 'portal-common/http';
import request from 'portal-common/service/fetch';
import { ACTIVITY_TYPE } from '../common/constants';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var API_MODULE_CMS = 'api';
var API_SUB_MODULE = 'tool';
var API_PREFIX = "/".concat(NAMESPACE.OPM_API, "/").concat(API_MODULE_CMS, "/").concat(API_SUB_MODULE);
var OPM_GET_LIST = "".concat(API_PREFIX, "/").concat(OPM_LIST_TAG);
var API_MODULE = 'v1';
var ACTION = 'cms-backend-cms';
var METHOD_PRVIEW = 'getPagePreview';
var METHOD = 'getPage';
var getPageDetail = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(eid) {
        var isPreview, url, result, code, msg, pageInfo, components, params, gemsPageData, _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    isPreview = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    url = "".concat(API_PROXY_PREFIX, "/").concat(NAMESPACE.QCINTL_WOA_API_DEV, "/").concat(ACTION, "/").concat(API_MODULE, "/").concat(isPreview ? METHOD_PRVIEW : METHOD);
                    _ctx.next = 4;
                    return api.call(url, {
                        method: 'post',
                        body: {
                            pageEid: eid
                        }
                    });
                case 4:
                    result = _ctx.sent;
                    code = result.code, msg = result.msg, pageInfo = result.data;
                    if (!(code === 0)) {
                        _ctx.next = 19;
                        break;
                    }
                    components = pageInfo.components, params = _objectWithoutProperties(pageInfo, [
                        "components"
                    ]);
                    gemsPageData = components.find(function(item) {
                        return item.componentId === 'GEMSPageData';
                    });
                    if (!gemsPageData) {
                        _ctx.next = 18;
                        break;
                    }
                    _ctx.prev = 10;
                    return _ctx.abrupt("return", {
                        code: 0,
                        msg: '',
                        data: _objectSpread({}, params, JSON.parse(gemsPageData.componentObject))
                    });
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](10);
                    logger.error('gemsPageData parse error', {
                        eid: eid,
                        error: _ctx.t0
                    });
                    return _ctx.abrupt("return", {
                        code: 1,
                        msg: '数据处理出错'
                    });
                case 18:
                    return _ctx.abrupt("return", {
                        code: 0,
                        msg: '',
                        data: pageInfo
                    });
                case 19:
                    logger.error('getPageDetail', _objectSpread({
                        eid: eid,
                        isPreview: isPreview
                    }, result));
                    return _ctx.abrupt("return", {
                        code: code,
                        msg: msg
                    });
                case 21:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                10,
                14
            ]
        ]);
    }));
    return function getPageDetail(eid) {
        return _ref.apply(this, arguments);
    };
}();
export { getPageDetail };
export var getOtherInfo = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var lang, preview;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    lang = param.lang, preview = param.preview;
                    return _ctx.abrupt("return", api.fetchMidProxy(OPM_GET_LIST, {
                        method: 'post',
                        body: {
                            positionId: getConfig(CONFIG_KEYS.opm).coupon.otherTips,
                            field: [
                                '*'
                            ],
                            page: 1,
                            num: 999,
                            lang: lang || 'en',
                            preview: ~~preview
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getOtherInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
export var getDiscountInfo = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var lang, preview;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    lang = param.lang, preview = param.preview;
                    return _ctx.abrupt("return", api.fetchMidProxy(OPM_GET_LIST, {
                        method: 'post',
                        body: {
                            positionId: getConfig(CONFIG_KEYS.opm).coupon.discountTips,
                            field: [
                                '*'
                            ],
                            page: 1,
                            num: 999,
                            lang: lang || 'en',
                            preview: ~~preview
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getDiscountInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
export var getCouponTipsInfo = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var lang, preview, eventType, positionId;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    lang = param.lang, preview = param.preview, eventType = param.eventType;
                    positionId = getConfig(CONFIG_KEYS.opm).coupon.otherTips;
                    if (ACTIVITY_TYPE.COUPON === eventType) {
                        // 代金券类型
                        positionId = getConfig(CONFIG_KEYS.opm).coupon.couponInfo;
                    } else if (ACTIVITY_TYPE.DISCOUNT === eventType) {
                        // 折扣类型
                        positionId = getConfig(CONFIG_KEYS.opm).coupon.discountTips;
                    } else if (ACTIVITY_TYPE.FULLBACK === eventType) {
                        // 满返类型
                        positionId = getConfig(CONFIG_KEYS.opm).coupon.fullbackTips;
                    }
                    return _ctx.abrupt("return", api.fetchMidProxy(OPM_GET_LIST, {
                        method: 'post',
                        body: {
                            positionId: positionId,
                            field: [
                                '*'
                            ],
                            page: 1,
                            num: 999,
                            lang: lang || 'en',
                            preview: ~~preview
                        }
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCouponTipsInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
export var getEidList = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(locales, modId) {
        var ACTION_MANAGE, API_PREFIX1, ref, result, code, msg, pageInfo, list, localList;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ACTION_MANAGE = 'cms-backend-manage';
                    API_PREFIX1 = "".concat(API_PROXY_PREFIX, "/").concat(NAMESPACE.QCINTL_WOA_API_DEV, "/").concat(ACTION_MANAGE, "/").concat(API_MODULE);
                    _ctx.next = 4;
                    return api.call("".concat(API_PREFIX1, "/listpage"), {
                        method: 'post',
                        body: {
                            mod_id: modId,
                            limit: 200,
                            offset: 0,
                            operator: 'garythtu'
                        }
                    });
                case 4:
                    ref = _ctx.sent;
                    result = ref.data;
                    code = result.ret_code, msg = result.ret_msg, pageInfo = result.page_info;
                    if (!(code === 0)) {
                        _ctx.next = 12;
                        break;
                    }
                    if (!(pageInfo.length > 0)) {
                        _ctx.next = 12;
                        break;
                    }
                    list = pageInfo.map(function(item) {
                        var pageEid = item.page_eid, pageObject = item.page_object;
                        var status = JSON.parse(pageObject).status;
                        if (status !== 1) {
                            return null;
                        }
                        var localData = locales.map(function(locale) {
                            return {
                                locale: locale,
                                params: {
                                    eid: pageEid
                                }
                            };
                        });
                        return localData;
                    }).filter(function(item) {
                        return item !== null;
                    });
                    localList = list.reduce(function(a, b) {
                        return a.concat(b);
                    });
                    return _ctx.abrupt("return", {
                        list: localList
                    });
                case 12:
                    logger.error('getEidList', _objectSpread({
                        modId: modId
                    }, result));
                    return _ctx.abrupt("return", {
                        code: code,
                        msg: msg,
                        list: []
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEidList(locales, modId) {
        return _ref.apply(this, arguments);
    };
}();
var TCE_DATA_COS_URL = "https://staticintl.cloudcachetci.com/tce_offical_website/data.json?t=".concat(new Date().getTime());
export var getTceTableData = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return request.get(TCE_DATA_COS_URL);
                case 2:
                    result = _ctx.sent.result;
                    logger.info('getTceTableData', {
                        result: result
                    });
                    if (!result) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        code: 0,
                        msg: '',
                        data: result
                    });
                case 6:
                    return _ctx.abrupt("return", {
                        code: -1,
                        msg: '数据请求出错'
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTceTableData() {
        return _ref.apply(this, arguments);
    };
}();
